import { z } from 'zod';

import { InstanceIdType } from '#core/schema/defs';
import { CogniteDescribableModel } from '#core/schema/model/cdm/CogniteDescribableModel';

export const CompletionModel = z.object({
  ...CogniteDescribableModel.shape,

  top: z.number().optional().describe('Top of the completion.'),
  base: z.number().optional().describe('Base of the completion.'),
  innerDiameter: z.number().optional().describe('Inner diameter of the completion.'),
  outerDiameter: z.number().optional().describe('Outer diameter of the completion.'),
  completionName: z.string().optional().describe('Name of the completion.'),
  equipmentLength: z.number().optional().describe('Length of the equipment used in the completion.'),
  wellboreGeometry: InstanceIdType.optional().describe('Reference to wellbore geometry data for this completion.'),
  string: InstanceIdType.optional().describe('Reference to string data for this completion.'),
});

export type CompletionModelInput = z.input<typeof CompletionModel>;
export type CompletionModelOutput = z.output<typeof CompletionModel>;
